export const isInterview = (node: any): boolean => {
  return node.interviewRequestKind === 'interview' || node.interviewContractKind === 'interview';
};

export const isBooking = (node: any): boolean => {
  return node.interviewRequestKind === 'booking' || node.interviewContractKind === 'booking';
};

export const getCardTitle = (node: any): 'Booking' | 'Interview' => {
  return node?.interviewContractKind === 'booking' ? 'Booking' : 'Interview';
};

export const isChimeSitting = (node: any): boolean => {
  return node.kind === 'chime_sitting';
};

export const getAvatarName = (node: any, isParent: boolean): string => {
  if (isParent) {
    const identifiedSitterName = node.identifiedSitters?.[0]?.sitter?.name;
    if (identifiedSitterName) {
      return identifiedSitterName;
    }
    return node.sitter?.name || '';
  }
  return node.parent?.name || '';
};

export const getAvatarPhotoUrl = (node: any, isParent: boolean): string => {
  if (isParent) {
    const identifiedSitterPhotoUrl = node.identifiedSitters?.[0]?.sitter?.photoUrl;
    if (identifiedSitterPhotoUrl) {
      return identifiedSitterPhotoUrl;
    }
    return node.sitter?.photoUrl || '';
  }
  return node.parent?.photoUrl || '';
};

export const getDisplayName = (node: any, isParent: boolean): string => {
  if (isParent) {
    const identifiedSitterName = node.identifiedSitters?.[0]?.sitter?.name;
    if (identifiedSitterName) {
      return identifiedSitterName;
    }
    if (isBooking(node) && node.invitedSitters?.[0]?.email) {
      return node.invitedSitters[0].email;
    }
    const sitterName = node.sitter?.name;
    if (sitterName) {
      return sitterName;
    }
    return '';
  }
  return node.parent?.name || '';
};

export const getInterviewRequestKind = (node: any): 'Booking' | 'Interview' => {
  return node?.interviewRequestKind === 'booking' || node?.interviewContractKind === 'booking' ? 'Booking' : 'Interview';
};

export const getSitterFromNode = (node: any): any => {
  return node?.identifiedSitters[0]?.sitter || node?.invitedSitters[0];
};
